import { getSessionVariable } from '@services/storage';

import { AppConfigType, EligibilityConfigType, WallConfigFileType, WallConfigType, WallType } from '@app-types/config';

import { generateConfig, isServer } from '@helpers/config';

import fs from 'fs';
import path from 'path';

let appMemoryConfig: string;

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'portailvente/product-wall'?: WallConfigFileType;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'portailvente/eligibility'?: EligibilityConfigType;
        portailvente?: Record<string, boolean>;
        // New unified config (progressive enhancement)
        appConfig?: AppConfigType;
    }
}

const getAppConfigContent = (): string => {
    if (appMemoryConfig === undefined) {
        appMemoryConfig = fs.readFileSync(path.resolve('./public', 'app-config.json'), 'utf8');
    }
    return appMemoryConfig;
};

export const getAppUnifiedConfig = (): AppConfigType => {
    if (isServer()) {
        return JSON.parse(getAppConfigContent()) as AppConfigType;
    }
    // Prefer new unified global if available; else reconstruct from legacy globals
    if (window.appConfig) return window.appConfig;
    return {
        walls: {} as WallConfigFileType,
        eligibility: {},
        features: {},
    };
};

export const getWallConfig = (type: WallType): WallConfigType => {
    const wallsConfig = getAppUnifiedConfig().walls;

    const filtersObject: WallConfigType['filtersObject'] = {};

    wallsConfig?.[type]?.filters?.forEach((filter) => {
        filtersObject[filter.key] = filter;
    });

    return { filtersObject, ...wallsConfig?.[type] };
};

export const getFeaturesConfig = (): Record<string, boolean> => {
    // Overwrite feature flags via session for dynamic changes.
    // This allows for the alteration of feature flags at runtime based on session variables.
    // Useful for testing or conditional feature deployment.
    // See feature module in https://gitlab.int.nbyt.fr/A360/the-monkeys-paw.
    if (isServer()) return getAppUnifiedConfig().features || {};
    const sessionFeatures = JSON.parse(getSessionVariable('portailvente_features') || '{}');
    const windowFeatures = getAppUnifiedConfig().features || {};
    return { ...windowFeatures, ...sessionFeatures };
};

export const getAppConfig = () => {
    return generateConfig();
};
